const SerialColumn = {
  Header: "#",
  width: 45,
  sortable: false,
  resizable: false,
  className: "text-center",
  Cell: ({ index }) => index + 1,
}

export default SerialColumn
